import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

import it from 'vuetify/es5/locale/it'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  lang: {
    locales: { it, pt },
    current: navigator.language.split('-')[0] || 'en'
  },
  theme: {
    dark: window.localStorage.getItem('dark') === 'true',
    themes: {
      light: {
        primary: colors.teal.base,
        secondary: colors.grey.darken3,
        accent: colors.pink.accent3,
        error: colors.red.accent2,
        info: colors.blue.base,
        success: colors.green.base,
        warning: colors.amber.base
      },
      dark: {
        primary: colors.teal.base,
        accent: colors.pink.accent3
      }
    }
  }
})
